import template from './activity-details.html'

export let activityDetails = {
  bindings: {
    activity: '<',
    details: '<',
    module: '<',
    label: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['Validations', '$stateParams',
    function activityDetailsCtrl (Validations, $stateParams) {
      const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
      const {
        inAcademicManagement,
        inTeaching,
        inConsolidation,
        inInvestigation,
        inExtension,
        isActivitiesType,
        isCommitteeParticipationType,
        isTeacherDevelopmentType,
        isProjectsType,
        isSubjectType,
        isPositionByDelegationType,
        isDoctoralEducationType,
        isProjectDesignType,
        isStudentAttentionType,
        isCommunityType,
        isProductsType,
        isInvestigationType,
        isResultsTransferType,
        isColaborationSpaceType,
        isInternalProjectsFormulationType,
        isExtensionProjectsType,
        isVisibilityType,
        isConsultancyType,
        isShortCoursesType,
        isCrossProjectFormulationType,
        isCrossExtensionProjectsType,
        inReview,
        inApproval,
        inExecution,
        inReviewExecution,
        inEvaluation
      } = Validations

      angular.extend(this, {
        inHistory: $stateParams.inHistory,
        inAcademicManagement: inAcademicManagement(this.module),
        inTeaching: inTeaching(this.module),
        inConsolidation: inConsolidation(this.module),
        inInvestigation: inInvestigation(this.module),
        inExtension: inExtension(this.module),
        isSubjectType: isSubjectType,
        isStudentAttentionType: isStudentAttentionType,
        isActivitiesType: isActivitiesType,
        isCommitteeParticipationType: isCommitteeParticipationType,
        isPositionByDelegationType: isPositionByDelegationType,
        isDoctoralEducationType: isDoctoralEducationType,
        isTeacherDevelopmentType: isTeacherDevelopmentType,
        isCommunityType: isCommunityType,
        isProjectsType: isProjectsType,
        isProjectDesignType: isProjectDesignType,
        isProductsType: isProductsType,
        isInvestigationType: isInvestigationType,
        isResultsTransferType: isResultsTransferType,
        isColaborationSpaceType: isColaborationSpaceType,
        isInternalProjectsFormulationType: isInternalProjectsFormulationType,
        isExtensionProjectsType: isExtensionProjectsType,
        isVisibilityType: isVisibilityType,
        isConsultancyType: isConsultancyType,
        isShortCoursesType: isShortCoursesType,
        isCrossProjectFormulationType: isCrossProjectFormulationType,
        isCrossExtensionProjectsType: isCrossExtensionProjectsType,
        inReview: inReview(currentStage),
        inApproval: inApproval(currentStage),
        inExecution: inExecution(currentStage),
        inReviewExecution: inReviewExecution(currentStage),
        inEvaluation: inEvaluation(currentStage),
        parentActivities: (activity) => {
          if (this.isProductsType(activity)) {
            return activity.isProjectsAssociated === 0
          } else {
            return this.isProjectsType(activity) || this.isExtensionProjectsType(activity) || this.isCrossExtensionProjectsType(activity)
          }
        },
        showEntriesList: (activity) => {
          if (this.isProductsType(activity) ||
              this.isProjectsType(activity) ||
              this.isExtensionProjectsType(activity) ||
              this.isCrossExtensionProjectsType(activity)
              ) {
            if (this.inExecution || this.inReviewExecution || this.inEvaluation) {
              return !activity.hoursChildren
            } else {
              return false
            }
          }

          if (this.inExecution || this.inReviewExecution || this.inEvaluation) {
            return this.isActivitiesType(activity) ||
                  this.isStudentAttentionType(activity) ||
                  this.inAcademicManagement ||
                  this.inConsolidation ||
                  this.inInvestigation ||
                  this.inExtension
          }
          return false
        },
        useMainInfo: (activity) => {
          return this.isResultsTransferType(activity) ||
                this.isProductsType(activity) ||
                this.isProjectsType(activity) ||
                this.isProjectDesignType(activity) ||
                this.isInvestigationType(activity) ||
                this.isColaborationSpaceType(activity) ||
                this.isCommunityType(activity) ||
                this.isDoctoralEducationType(activity) ||
                this.isInternalProjectsFormulationType(activity) ||
                this.isExtensionProjectsType(activity) ||
                this.isVisibilityType(activity) ||
                this.isConsultancyType(activity) ||
                this.isShortCoursesType(activity) ||
                this.isCrossProjectFormulationType(activity) ||
                this.isCrossExtensionProjectsType(activity)
        }
      })
    }
  ]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details.js